import { render, staticRenderFns } from "./free-user-tips.vue?vue&type=template&id=3ac8f284&"
import script from "./free-user-tips.vue?vue&type=script&lang=js&"
export * from "./free-user-tips.vue?vue&type=script&lang=js&"
import style0 from "./free-user-tips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports